import { style } from 'typestyle'
export const z2 = style({ zIndex: 2 })
